import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 3rem;
	padding: 4rem;
`;

export const ImageContainer = styled.div`
	flex-shrink: 0;
	& > img {
		border-radius: 50%;
	}

	.icon {
		border-radius: 50% !important;
	}
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	text-align: center;
`;
